var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsKoneApis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons-kone-apis",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10939",
    "data-name": "Path 10939",
    d: "M19.976,6.943A3.58,3.58,0,0,1,16.4,10.518h-.419V9.2H16.4a2.259,2.259,0,0,0,.087-4.517l-.087,0a2.247,2.247,0,0,0-1.288.4,2.259,2.259,0,1,0-4.458-.512,2.286,2.286,0,0,0,.014.246A2.258,2.258,0,1,0,9.9,9.2h.985v1.316H9.9a3.576,3.576,0,0,1-.354-7.134,3.576,3.576,0,0,1,6.738-.015l.121,0A3.58,3.58,0,0,1,19.976,6.943Zm-3.405,5.641-1.94-1.827V7.749h-.987V10.97a.493.493,0,0,0,.155.359l2.1,1.973a1.184,1.184,0,1,0,.677-.719Zm-2.91,1.654V12.3a.494.494,0,0,0-.156-.36l-.835-.783V7.749h-.987v2.9L9.735,12.574a1.185,1.185,0,1,0,.694.7l1.486-1.469.759.711v1.719a1.185,1.185,0,1,0,.987,0Z",
    transform: "translate(-5.149 -0.749)",
    fill: "#c6cacc"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsKoneApis);
export default __webpack_public_path__ + "static/media/icons-kone-apis.7b1a5b1e.svg";
export { ForwardRef as ReactComponent };